import * as React from "react";
const SvgDevianart = props => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={{
  enableBackground: "new 0 0 24 24"
}} xmlSpace="preserve" width={512} height={512} {...props}><path d="m8.973 11.228-.36-.435h-4.04V4.8h7.349l.647-.437L14.628.439 15.064 0h4.363v4.364l-4.399 8.405.359.438h4.04V19.2h-7.349l-.647.437-2.059 3.924-.436.439H4.573v-4.364z" /></svg>;
export default SvgDevianart;